import { useQuery } from "react-query";
import api from "../services/api";
import queryKeys from "./queryKeys";

const DASHBOARD_CACHE_TTL = 5 * 60 * 1000;

const fetchDashboardSummary = async ({ queryKey }) => {
  const [, , params] = queryKey;
  const { data } = await api.get("/dashboard", {
    params,
  });
  return data;
};

export const useDashboardSummaryQuery = ({ companyId, params, enabled = true }) =>
  useQuery(queryKeys.dashboard.summary(companyId, params), fetchDashboardSummary, {
    enabled,
    keepPreviousData: true,
    meta: {
      persist: {
        maxAge: DASHBOARD_CACHE_TTL,
      },
    },
  });
